// src/auth/signInTowing.js
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { towingLogin, setTowingAuth } from "../api/towingApi";

export async function signInTowing(email, password, remember) {
  const auth = getAuth();
  await setPersistence(
    auth,
    remember ? browserLocalPersistence : browserSessionPersistence
  );
  const cred = await signInWithEmailAndPassword(auth, email, password);
  const idToken = await cred.user.getIdToken(true); // fresh
  const res = await towingLogin({ idToken, remember });
  setTowingAuth({ user: { email: cred.user.email } }, remember);
  return res;
}
